<template>
  <div class="m-top4 m-bottom4" v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <a v-if="onlyOneChild.meta" class="nav-item">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown': !isNest}" @click.native.stop="clickNav(item.path)">
          <item :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </a>
    </template>

    <el-submenu v-else ref="subMenu" :class="[item.path == titlePath ? 'is-active-title' : '']" :index="resolvePath(item.path)" popper-append-to-body @click.native="clickNav(item.path, $event)">
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/libs/validate'
import Item from './menuItem'
import AppLink from './link'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {
      titlePath: ""
    }
  },
  mounted() {},
  methods: {
    hasOneShowingChild(children = [], parent) {
      if (!children) {
        children = [];
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath, routeQuery) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery);
        return { path: path.resolve(this.basePath, routePath), query: query }
      }
      return path.resolve(this.basePath, routePath)
    },
    clickNav(name, event) {
      this.titlePath = name;
      const submenuList = document.querySelectorAll(".el-submenu");
      submenuList.forEach(item => {
        item.classList.remove("is-active-title");
      });
      if (event) {
        const menuList = document.querySelectorAll(".el-menu-item");
        menuList.forEach(item => {
          item.classList.remove("is-active");
        });
        event.currentTarget.classList.add("is-active-title");
      }
      const path = this.$route.meta.listPath;
      const type = name == "全部" ? "" : name;
      if (this.basePath == type) {
        this.$router.push(path + "?type1=" + type);
      } else {
        const arr = this.basePath.split("/").filter(item => {
          return item != "";
        });
        this.$router.push(path + "?type1=" + arr[0] + "&type2=" + arr[1]);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-menu {
  border: none;
  background-color: transparent !important;
  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    border-radius: 8px;
    font-size: 16px;
  }
  /deep/ .el-menu-item.is-active {
    background: #2960a7;
    color: #fff;
  }
  .is-active-title /deep/ .el-submenu__title {
    background: #2960a7;
    color: #fff;
  }
}
</style>
